import React from "react";
import { Box, Button, Typography } from "@mui/material";

const DashboardComponent = ({
  title,
  paragraph,
  icon,
  handleButtonClick,
  count,
}) => {
  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      mt={5}
      sx={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "20px",
        maxHeight: "15em",
        position: "relative",
        marginBottom: "20px",
      }}
    >
      <Box sx={{ mb: 10, width: "100px", height: "100px" }}>{icon}</Box>
      <Box
        sx={{
          mb: 10,
          marginLeft: "20px",
          maxWidth: "300px",
        }}
      >
        <Typography variant={"h3"}>{title}</Typography>

        {count && (
          <Typography
            variant={"h4"}
            sx={{
              background: "#FFEB3B",
              display: "inline-block",
              borderRadius: "20px",
              padding: "5px 10px",
              marginTop: "10px",
              color: "#000",
            }}
          >
            Συνολικά: {count}
          </Typography>
        )}
        <Typography mt={2} variant={"subtitle2"}>
          {paragraph}
        </Typography>
        <Button
          variant={"contained"}
          onClick={handleButtonClick}
          sx={{
            position: "absolute",
            bottom: "20px",
            right: "20px",
            margin: "10px",
          }}
        >
          Μετάβαση
        </Button>
      </Box>
    </Box>
  );
};

export default DashboardComponent;
